<template>
  <div :class="$style.container">
    <span :class="$style.title">
      {{ content.name }}
    </span>
    <ul :class="$style.list">
        <li v-for="val in content.values" :key="val.value">
          <input :class="$style.radio" type="radio" :id="val.value" :name="content.name" :value="val.value">
          <label :class="$style.label" :for="val.value">
            <span v-if="content.name === 'Color'" :style="{ background: val.value }"></span>
            <span v-else v-html="val.value"></span>
          </label>
        </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ['content']
}
</script>

<style module lang="scss">
.container {
  width: 100%;
  margin: $small-margin 0;
  flex: 0 1 100%;
}

.title {
  font-size: font-size(s);
  color: $color-blue;
  letter-spacing: 3px;
  text-transform: uppercase;
  font-weight: 600;
}

.list {
  display: flex;
  margin: $small-margin 0;
}

$radio-size: 28px;

.radio:checked,
.radio:not(:checked) {
  position: absolute;
  left: -9999px;

  & + label {
    display: block;
    position: relative;
    cursor: pointer;
    width: $radio-size;
    height: $radio-size;
    margin-right: 15px;

    &::after {
      content: "";
      position: absolute;
      top: -1px;
      left: -1px;
      border-radius: 100%;
      width: $radio-size + 2px;
      height: $radio-size + 2px;
      background: white;
      transition: transform 0.3s ease-out;
      z-index: -1;
    }
  }

  & + label span {
    display: block;
    background: $color-dark;
    color: white;
    text-align:center;
    width: 100%;
    height: 100%;
    line-height: $radio-size;
    text-transform: uppercase;
    font-size: font-size(s);
    font-weight: 600;
    border-radius: 100%;
    transition: transform 0.3s ease-out;
  }
}

.radio:checked + label span {
  transform: scale(1.2);
}
</style>



// WEBPACK FOOTER //
// src/components/OptionsChoice.vue